import { useLingui } from "@lingui/react/macro";

import { formatClock } from "../../model/formatClock";
import type { HighlightsMatch } from "../../model/Highlight";

const DAY_MS = 86_400_000;

const startOfDay = (date: Date): number =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

// Строка «сегодня, 16:49 · 30:02» под героем матча: когда начался (сегодня и вчера — словом,
// раньше — датой) и сколько шёл.
export const useMatchMeta = (): ((match: HighlightsMatch, now?: Date) => string) => {
  const { i18n } = useLingui();
  const time = new Intl.DateTimeFormat(i18n.locale, { hour: "2-digit", minute: "2-digit" });
  const day = new Intl.DateTimeFormat(i18n.locale, { day: "numeric", month: "short" });
  const relative = new Intl.RelativeTimeFormat(i18n.locale, { numeric: "auto" });
  return (match, now = new Date()) => {
    const parts: string[] = [];
    if (match.started_at !== null) {
      const started = new Date(match.started_at);
      const daysAgo = Math.round((startOfDay(now) - startOfDay(started)) / DAY_MS);
      const when =
        daysAgo === 0 || daysAgo === 1 ? relative.format(-daysAgo, "day") : day.format(started);
      parts.push(`${when}, ${time.format(started)}`);
    }
    if (match.duration_s !== null) {
      parts.push(formatClock(match.duration_s));
    }
    return parts.join(" · ");
  };
};
